export default __webpack_public_path__ + "static/media/GuessJobs2_18.078ca9b9.png";